<!--
  --
  -- 登録内容の確認 グループ
  --
  -->
<template>
  <v-card
    :errors="errors"
  >
    <!-- Title -->
    <v-card-title v-if="$scopedSlots.title">
      <slot name="title"/>
    </v-card-title>

    <!-- Contents -->
    <v-card-text>
      <slot/>

      <v-row>
        <v-col cols="12">
          <c-summary-account :account="user.account"/>
        </v-col>
        <v-col cols="12" sm="6">
          <c-summary-profile :profile="user.profile"/>
        </v-col>
        <v-col cols="12" sm="6">
          <c-summary-license :license="user.license"/>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- Actions -->
    <v-card-actions>
      <v-spacer/>

      <v-btn
        color="primary"
        :loading="running"
        :disabled="running"
        @click="onSubmit"
      >
        <slot name="submit-text"/>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CSummaryAccount from './CSummaryAccount'
import CSummaryProfile from './CSummaryProfile'
import CSummaryLicense from './CSummaryLicense'

export default {
  name: 'CConfirmGroup',
  components: {
    CSummaryAccount,
    CSummaryProfile,
    CSummaryLicense
  },
  props: {
    /**
     * ユーザ情報
     */
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    // フォームのエラーメッセージ
    errors: [],

    // 処理中
    running: false
  }),
  methods: {
    /**
     * Submit ボタンが押された
     */
    onSubmit () {
      // エラー表示を消す
      this.errors = []

      // フォーム入力されたことを通知する
      this.running = true
      this.$emit('submit', errors => {
        this.running = false
        if (errors) {
          this.errors = errors
        }
      })
    }
  }
}
</script>
